import { render, staticRenderFns } from "./AlertPage.vue?vue&type=template&id=41ba9461&scoped=true&"
import script from "./AlertPage.vue?vue&type=script&lang=js&"
export * from "./AlertPage.vue?vue&type=script&lang=js&"
import style0 from "./AlertPage.vue?vue&type=style&index=0&id=41ba9461&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba9461",
  null
  
)

export default component.exports